(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/about-bankid.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/about-bankid.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.behaviors.AboutBankid = Marionette.Behavior.extend({
    ui: {
      aboutBankidLink: '.js-about-bankid'
    },
    events: {
      'click @ui.aboutBankidLink': 'onAboutBankidClick'
    },
    onAboutBankidClick: function onAboutBankidClick() {
      svs.components.Modal.show(svs.player_login.templates.about_bankid(), null, {
        title: 'Om BankID',
        leftButton: {
          text: 'Tillbaka',
          visible: true
        },
        rightButton: {
          visible: false
        }
      });
    }
  });
})(Backbone, _, svs);
 })(window);